import { config } from "../env";
import {
  Delete,
  get,
  patch,
  patchFileUpload,
  post,
  postFileUpload,
} from "./helpers/http-handler";

export const getSupportList = (queryRequest: string) =>
  get(`${config.API_URL}/support?${queryRequest}`);

export const getSpecificSupportTicket = (id: string) =>
  get(`${config.API_URL}/support/${id}`);

export const createSupportTicket = (payload: object) =>
  post(`${config.API_URL}/support`, payload);

export const updateSupportTicket = (id: string, payload: object) =>
  patch(`${config.API_URL}/support/${id}`, payload);

export const deleteSupportTickets = (id: String) =>
  Delete(`${config.API_URL}/support/${id}`);

//Support - upload

export const uploadSupportTicket = (id: any, payload: any) =>
  patch(`${config.API_URL}/support/${id}/upload/document`, payload);

export const deleteSupportTicket = (id: any, deleteId: any) =>
  Delete(`${config.API_URL}/support/${id}/document/${deleteId}`);

export const clientFileUploads = (payload: object) =>
  postFileUpload(`${config.API_URL}/media-uploads/file/upload`, payload);

// export

export const exportSupport = (payload: object) =>
  post(`${config.API_URL}/reports/export-support`, payload);

//Logs Added
export const adminCreateGroup = (payload: object) =>
  post(`${config.API_URL}/groups`, payload);

export const adminGetGroups = (queryRequest: string) =>
  get(`${config.API_URL}/groups?${queryRequest}`);

export const adminGetSpecificGroup = (id: string) =>
  get(`${config.API_URL}/groups/${id}`);

export const adminUpdateSpecificGroup = (id: string, payload: object) =>
  patch(`${config.API_URL}/groups/${id}`, payload);

export const adminDeleteSpecificGroup = (id: string) =>
  Delete(`${config.API_URL}/groups/${id}`);

export const adminUpdateBulkGroupStatus = (payload: object) =>
  patch(`${config.API_URL}/groups/bulk/active-inactive`, payload);

export const getComplianceReports = (queryRequest: string) =>
  get(`${config.API_URL}/reports?${queryRequest}`);

//List
export const getUserGuideList = (queryRequest: string) =>
  get(`${config.API_URL}/user-guide?${queryRequest}`);
